export enum WarrntyFileItemSteps {
  MISSING_ITEM = "Missing Line Item.",
  LINE_ITEM = "Line Item",
}

export const WarrntyItemSteps = [
  {
    step_num: 1,
    title: WarrntyFileItemSteps.MISSING_ITEM,
  },
  {
    step_num: 2,
    title: WarrntyFileItemSteps.LINE_ITEM,
  },
];
